import {useQuery} from "@tanstack/react-query";
import {getCurrentUser} from "../services/apiAuth.js";

export function useUser() {
    const { isLoading, data: user } = useQuery({
        queryKey: ["user"],
        queryFn: getCurrentUser
    });

    // return { isLoading, user, isAuthenticated: user?.role === "authenticated" };

    return {
        isLoading,
        user,
        isAuthenticated: !!user?.id, // ✅ true if user exists
    };
}